/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberDinghyBookingDetailDialogController', MemberDinghyBookingDetailDialogController);

    MemberDinghyBookingDetailDialogController.$inject = ['$timeout', '$scope', '$state', '$uibModalInstance', 'ProfileService', '$http', '$sce', 'AlertService', 'entity', '$filter'];

    function MemberDinghyBookingDetailDialogController ($timeout, $scope, $state, $uibModalInstance, ProfileService, $http, $sce, AlertService, entity, $filter) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.booking = {};
        vm.booking.id = vm.dinghyEvent.bookingId;
        vm.booking.bookingStatus = vm.dinghyEvent.bookingStatus;
        vm.booking.dinghy = vm.dinghyEvent.bookedDinghy;
        vm.booking.commentDinghy = vm.dinghyEvent.commentDinghy;
        var editDateCheck = new Date();
        editDateCheck.setDate(editDateCheck.getDate() - 1);
        vm.disableEdit = vm.booking.bookingStatus === 'abgelehnt' || vm.dinghyEvent.fromDate < editDateCheck || vm.dinghyEvent.closed;

        $scope.status = {
            descriptionOpen: vm.booking.id == null,
            conditionsOpen: false,
            editOpen: false
        };

        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            $http.put('api/member/dinghy-bookings/', vm.booking).then(function(response) {
                vm.error = null;
                $uibModalInstance.close(response);
                vm.isSaving = false;
            }, function() {
                vm.isSaving = false;
            });
        }

        $scope.getChangeState = function() {
            return $state.includes('member.dinghy-events') ? "member.dinghy-events.change({id: vm.dinghyEvent.id})" : "member.dinghy-booking.change({id: vm.dinghyEvent.id})";
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        var trusted = {};
        $scope.getPopoverContent = function(content) {
            return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
        }
    }
})();
